import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';

export const InvoiceDetailContainer = styled.div`
    width: ${({ width }) => (width ? width : '100%')};
    display: flex;
    margin-top: ${({ desktopMarginTop }) =>
        desktopMarginTop ? desktopMarginTop : '16px'};
    ${media.mobileDevice`
        margin-top: ${({ mobileMarginTop }) =>
            mobileMarginTop ? mobileMarginTop : '16px'};
    `}
`;
export const InvoiceDataContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    margin: 0 1rem 0 0;
    align-items: ${({ alignItemInvoice }) =>
        alignItemInvoice ? alignItemInvoice : 'center'};
    ${media.mobileDevice`
        margin: ${({ invoiceDataMargin }) =>
            invoiceDataMargin ? invoiceDataMargin : '0'};
    `};
`;

export const OrderTypeSpanContianer = styled.div`
    width: 24px;
    height: 18px;
    position: relative;
    margin-top : ${({marginTop })=> (marginTop ? '4px' : null)};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '3px')};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '10px')};
    opacity: 1;
    background: transparent url(${({ sourcePath }) => sourcePath}) 0% 0%
        no-repeat padding-box;
    ${media.mediumDevice`
        width: 20px;
         background: transparent url(${({ ipadSourcePath }) =>
             ipadSourcePath}) 0% 0%
        no-repeat padding-box;
    `};
    ${media.portraitDevice`
        width: 20px;
         background: transparent url(${({ ipadSourcePath }) =>
             ipadSourcePath}) 0% 0%
        no-repeat padding-box;
    `};
    ${media.smalDevice`
        width: 20px;
         background: transparent url(${({ ipadSourcePath }) =>
             ipadSourcePath}) 0% 0%
        no-repeat padding-box;
    `};
    ${media.mobileDevice`
        width: 24px;
        background: transparent url(${({ sourcePath }) => sourcePath}) 0% 0%
        no-repeat padding-box;
    `};
`;

export const OrderCountContainer = styled.div`
    display: ${({ display }) => (display ? display : 'inline-block')};
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: #c529bb;
    top: -5px;
    right: -8px;
`;

export const OrderCountSpan = styled.span`
    font-family: 'AvenirNextWorld Demi';
    font-size: 8px;
    color: #ffffff;
    text-align: center;
    position: absolute;
    width: 100%;
`;

export const InvoiceStatusPrice = styled.p`
    margin: 0;
    display: inline-block;
    font-family: ${({ fontFamily, isInvoiceStatus, isPrice }) =>
        fontFamily
            ? fontFamily
            : isInvoiceStatus
            ? 'AvenirNextWorld Demi'
            : isPrice && 'AvenirNextWorld Bold'};
    letter-spacing: 0px;
    opacity: ${({ isInvoiceStatus, isPrice }) =>
        isInvoiceStatus ? '1' : isPrice && '0.9'};
    color: ${({ isPrice }) => (isPrice ? '#C529BB' : '#585858')};
    font-size: ${({ priceFontSize, isInvoiceStatus, isPrice }) =>
        priceFontSize
            ? priceFontSize
            : isInvoiceStatus
            ? '13px'
            : isPrice && '14px'};
    line-height: ${({ isInvoiceStatus, isPrice }) =>
        isInvoiceStatus ? '22px' : isPrice && '24px'};

    ${({ isPrice }) =>
        isPrice &&
        css`
            &:before {
                // content: '$';
                font-family: ${({ fontFamily }) =>
                    fontFamily ? fontFamily : 'AvenirNextWorld Bold'};
                font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
            }
        `};

    ${media.mobileDevice`
        font-size: ${({ isInvoiceStatus }) => isInvoiceStatus && '12px'};
    `}

    @media only screen and (max-device-width: 375px) {
        font-size: 11px !important;
    }
    @media only screen and (max-device-width: 375px) {
        font-size: 10px !important;
    }
`;
